const TOPICS = [
  {
    title: '热播电视剧',
    desc: '国产剧·韩剧·美剧·日剧 每日更新',
    icon: 'ri-tv-line',
    color: 'primary',
  },
  {
    title: '院线大片',
    desc: '最新上映·经典回顾·系列合集',
    icon: 'ri-film-line',
    color: 'accent',
  },
  {
    title: '热门综艺',
    desc: '真人秀·脱口秀·选秀·音乐竞技',
    icon: 'ri-mic-line',
    color: 'secondary',
  },
  {
    title: '动漫番剧',
    desc: '日漫·国漫·剧场版·OVA合集',
    icon: 'ri-ghost-line',
    color: 'primary',
  },
  {
    title: '纪录片',
    desc: '自然·历史·科技·人文纪实',
    icon: 'ri-earth-line',
    color: 'accent',
  },
  {
    title: '少儿频道',
    desc: '动画片·儿歌·早教·亲子内容',
    icon: 'ri-heart-line',
    color: 'secondary',
  },
  {
    title: '体育赛事',
    desc: '足球·篮球·电竞·格斗赛事回放',
    icon: 'ri-basketball-line',
    color: 'primary',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-50">
            精彩专题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            海量影视资源按类别精心整理，轻松找到你想看的内容
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {TOPICS.map((item) => {
            const iconBg =
              item.color === 'primary'
                ? 'bg-primary-500/15 text-primary-400'
                : item.color === 'accent'
                  ? 'bg-accent-500/15 text-accent-400'
                  : 'bg-secondary-500/15 text-secondary-400';
            const hoverBorder =
              item.color === 'primary'
                ? 'hover:border-primary-500/30'
                : item.color === 'accent'
                  ? 'hover:border-accent-500/30'
                  : 'hover:border-secondary-500/30';
            return (
              <a
                key={item.title}
                href="#index"
                className={`group flex flex-col items-center text-center p-5 md:p-6 rounded-xl bg-background-50 border border-background-300/20 transition-all duration-200 cursor-pointer ${hoverBorder} hover:bg-background-50/80`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${iconBg} mb-3 transition-transform duration-200 group-hover:scale-110`}>
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-100 whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}